import {
  UpdateLocationPayload,
  CreateUpdateLocationResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateAdminLocation(
  tenantId: string,
  locationId: number,
  onSuccess?: (data: CreateUpdateLocationResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/locations/${locationId}`;
  const request = new Request(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    CreateUpdateLocationResponse,
    UpdateLocationPayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['admin-tenants'],
      ['admin-tenant-details', tenantId],
    ],
    onSuccess,
    onError,
  });
}

export default useUpdateAdminLocation;
